export default __webpack_public_path__ + "static/media/all_in_one_app_en.442411d6.png";